"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    STANDARD: 'direction-standard',
    REVERSE: 'direction-reverse',
};
//# sourceMappingURL=directions.js.map